import { useRewardsPointsPerSecond, useLoanMultipliersUtil, BsMetaUtil } from "@bridgesplit/abf-react";
import { StatColumn, Icon, useAppPalette, StatProps } from "@bridgesplit/ui";
import { filterTruthy, formatMultiplier } from "@bridgesplit/utils";
import { BoltOutlined } from "@mui/icons-material";

import { CaptionWithIcon } from "../common";
import { RewardsDailyPointsProps } from "./RewardsDailyPoints";

export function RewardsDailyPointsBreakdown({
    loopscalePointsAction,
    metadata,
    collateralMetadata
}: RewardsDailyPointsProps) {
    const { rewardPointsPerSecond, isLoading: isRelativePointsLoading } = useRewardsPointsPerSecond();
    const { loanMultipliers, isLoading: isLoadingLoanMultipliers } = useLoanMultipliersUtil();
    const { prime, secondary } = useAppPalette();

    const isLoading = isRelativePointsLoading || isLoadingLoanMultipliers;

    // Get the shared points per second and label for the action
    const relativePointsPerSecond = rewardPointsPerSecond?.[loopscalePointsAction]?.relativePointsPerSecond;
    const rewardLabel = rewardPointsPerSecond?.[loopscalePointsAction]?.rewardLabel;

    // Always show the points stat (shared for all metadatas)
    const pointsStat: StatProps = {
        caption: (
            <CaptionWithIcon
                variant="body2"
                icon={<Icon type="points" />}
                iconColor={secondary}
                caption={rewardLabel}
            />
        ),
        value: formatMultiplier(relativePointsPerSecond),
        variant: "body2"
    };

    // Build a list of StatProps for boosts
    const boostStats: StatProps[] = [];
    if (metadata && loanMultipliers?.[metadata.mint]?.[loopscalePointsAction]?.multiplier) {
        boostStats.push({
            caption: (
                <CaptionWithIcon
                    icon={<BoltOutlined />}
                    iconColor={prime}
                    variant="body2"
                    caption={`${BsMetaUtil.getSymbol(metadata)} boost`}
                />
            ),
            value: formatMultiplier(loanMultipliers[metadata.mint][loopscalePointsAction].multiplier),
            variant: "body2"
        });
    }

    if (collateralMetadata && loanMultipliers?.[collateralMetadata.mint]?.[loopscalePointsAction]?.multiplier) {
        boostStats.push({
            caption: (
                <CaptionWithIcon
                    icon={<BoltOutlined />}
                    iconColor={prime}
                    variant="body2"
                    caption={`${BsMetaUtil.getSymbol(collateralMetadata)} boost`}
                />
            ),
            value: formatMultiplier(loanMultipliers[collateralMetadata.mint][loopscalePointsAction].multiplier),
            variant: "body2"
        });
    }

    const stats = [pointsStat, ...boostStats].filter(filterTruthy);

    return <StatColumn stats={stats} loading={isLoading} spacing={0.5} />;
}
